import { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { isValid, parse, format } from "date-fns";

import { TextField } from "../components";

const DATE_FORMAT = "dd/MM/yyyy hh:mm a";

const formatDateTimeInput = (value) => {
  const upperValue = value.toUpperCase();

  const letters = upperValue.replace(/[^APM]/g, "").slice(0, 2);

  let period = "";

  if (letters.startsWith("P")) {
    period = letters.length > 1 ? "PM" : "P";
  }

  if (letters.startsWith("A")) {
    period = letters.length > 1 ? "AM" : "A";
  }

  const digits = upperValue.replace(/\D/g, "").slice(0, 12);

  let result = "";

  if (digits.length > 0) {
    result += digits.slice(0, 2);
  }

  if (digits.length > 2) {
    result += `/${digits.slice(2, 4)}`;
  }

  if (digits.length > 4) {
    result += `/${digits.slice(4, 8)}`;
  }

  if (digits.length > 8) {
    result += ` ${digits.slice(8, 10)}`;
  }

  if (digits.length > 10) {
    result += `:${digits.slice(10, 12)}`;
  }

  if (period) {
    result += ` ${period}`;
  }

  return result;
};

export default function MuiDateTimePicker({
  value,
  onChange,
  name,
  disabled = false,
  required = false,
  disablePast = false,
  minDateTime,
  formikProps,
}) {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!value) {
      setInputValue("");
      return;
    }

    const date = new Date(value);

    if (isValid(date)) {
      setInputValue(format(date, DATE_FORMAT));
    }
  }, [value]);

  const handleInputChange = (event) => {
    const formattedValue = formatDateTimeInput(event.target.value);

    setInputValue(formattedValue);

    const parsedDate = parse(formattedValue, DATE_FORMAT, new Date());

    if (isValid(parsedDate)) {
      onChange(parsedDate);
    }
  };

  const handlePickerChange = (newValue) => {
    if (!newValue) {
      return;
    }

    const date = new Date(newValue);

    if (!isValid(date)) {
      return;
    }

    setInputValue(format(date, DATE_FORMAT));

    onChange(date);
  };

  return (
    <DateTimePicker
      value={value ? new Date(value) : null}
      disabled={disabled}
      disablePast={disablePast}
      minDateTime={minDateTime}
      onChange={handlePickerChange}
      inputFormat={DATE_FORMAT}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          autoComplete="off"
          disabled={disabled}
          name={name}
          formikProps={formikProps}
          value={inputValue}
          onChange={handleInputChange}
          inputProps={{
            ...params.inputProps,
            value: inputValue,
            onChange: handleInputChange,
            placeholder: "DD/MM/YYYY HH:MM AM",
          }}
        />
      )}
    />
  );
}
